import React, { useState } from 'react';
import { Text, View } from 'react-native';
import DateTimePicker from 'react-native-ui-datepicker';
import i18n from 'i18n-js';
import moment from 'moment';

import { scale } from '@components/frame';
import { font } from '@styles/fonts';
import { isWeb, localTime, toMoment } from '@helpers';

import Svg from '@styles/icons/svg';
import Button from '@styles/buttons';
import ColorWrapper from '@styles/colors';

const CalendarListScreen = ({ C, selectedChartDate, setSelectedChartDate, hide, mode = 'single', selectRange, selectedRange }) => {
  const [range, setRange] = useState(() =>
    mode === 'range' && selectedRange?.start && selectedRange?.end
      ? { startDate: new Date(selectedRange.start), endDate: new Date(selectedRange.end) }
      : { startDate: undefined, endDate: undefined }
  );

  const onDayPress = (params) => {
    switch (mode) {
      case 'single': {
        if (params.date) {
          const d = moment(params.date.$d).format('YYYY-MM-DDTHH:mm:ss');
          hide();
          setSelectedChartDate(localTime(d).format());
        }
        return;
      }
      case 'range': {
        return setRange(params);
      }
    }
  };

  const current = selectedChartDate ? localTime(selectedChartDate).format('YYYY-MM-DD') : localTime().format('YYYY-MM-DD');

  const BackIcon = ({ transform }) => {
    return (
      <View style={{ transform: [{ rotate: transform ? '180deg' : '0deg' }] }}>
        <Svg icon="chevronRightLight" color="Link/Light/Primary" width={scale(11)} height={scale(11)} />
      </View>
    );
  };

  const isDoneDisabled = (() => {
    switch (mode) {
      case 'range': {
        if (!range.startDate) {
          return true;
        }
      }
    }
    return false;
  })();

  const donePress = () => {
    if (isDoneDisabled) {
      hide();
      return;
    }
    switch (mode) {
      case 'single': {
        hide();
        return;
      }
      case 'range': {
        if (range.startDate && range.endDate) {
          const sT = toMoment(range.startDate).format('YYYY-MM-DDTHH:mm:ss');
          const start = localTime(sT).startOf('day').format();
          const eT = toMoment(range.endDate).startOf('day').format('YYYY-MM-DDTHH:mm:ss');
          const end = localTime(eT).endOf('day').format();
          hide();
          selectRange({ start, end });
          return;
        }

        if (range.startDate) {
          const d = toMoment(range.startDate).format('YYYY-MM-DDTHH:mm:ss');
          hide();
          setSelectedChartDate(localTime(d).format());
          return;
        }
      }
    }
  };

  const datePickerTextColor = C('Label/Light/Primary');

  return (
    <View style={[isWeb && { flex: 1 }, { paddingTop: scale(58) }]}>
      <View
        style={{
          width: '100%',
          zIndex: 1000,
          height: scale(58),
          position: 'absolute',
          top: 0,
        }}
      >
        <View style={{ position: 'absolute', zIndex: 1000, left: 0, padding: 8 }}>
          <Button
            {...{
              variant: 'M',
              type: 'Only Text Link',
              onPress: () => {
                setSelectedChartDate(localTime().utc().format());
                hide();
              },
            }}
          >
            <Text style={[{ color: C('Link/Light/Primary') }, font.Headline]}>{i18n.t('Today')}</Text>
          </Button>
        </View>
        <View style={{ position: 'absolute', zIndex: 1000, right: 0, padding: 8 }}>
          <Button
            {...{
              variant: 'M',
              type: 'Only Text',
              onPress: donePress,
            }}
          >
            <Text style={[{ color: C('Link/Light/Primary') }, font.Headline]}>{i18n.t(isDoneDisabled ? 'Close' : 'Done')}</Text>
          </Button>
        </View>
        <View style={{ width: '100%', position: 'absolute', zIndex: 100, top: scale(15) }}>
          <Text style={[{ color: C('Label/Light/Primary'), width: '100%', textAlign: 'center' }, font.Headline]}>{i18n.t('Calendar')}</Text>
        </View>
      </View>
      <View style={{ padding: scale(15) }}>
        <DateTimePicker
          mode={mode}
          date={current}
          startDate={range.startDate}
          endDate={range.endDate}
          maxDate={localTime().add(1, 'day').format('YYYY-MM-DD')}
          onChange={onDayPress}
          firstDayOfWeek={1}
          headerButtonStyle={{
            width: 20,
            height: 20,
          }}
          headerButtonSize={20}
          buttonPrevIcon={<BackIcon {...{ transform: true }} />}
          buttonNextIcon={<BackIcon {...{ transform: false }} />}
          todayContainerStyle={{ borderWidth: 0 }}
          calendarTextStyle={{ color: datePickerTextColor }}
          headerTextStyle={{ color: datePickerTextColor }}
          weekDaysTextStyle={{ color: datePickerTextColor }}
        />
      </View>
    </View>
  );
};

export default ColorWrapper(CalendarListScreen);
